function isPositiveInteger(i: number): boolean {
  return isFinite(i) && i > 0;
}

// return a integer representing the payout amount in cents
export function normalizeDollarAmount(payoutAmount: string): number | false {
  const trimmedPayoutAmount = payoutAmount.trim();
  const characters = trimmedPayoutAmount.split("");

  // can only have at most one decimal point
  const decimalCount = characters.filter((c) => c === ".").length;
  if (decimalCount > 1) {
    return false;
  }

  // can only contain digits and at most one decimal point
  const validCharacters = characters.filter(
    (c) => c === "." || /[0-9]/.test(c)
  );
  if (validCharacters.length !== characters.length) {
    return false;
  }

  const decimalIndex = characters.indexOf(".");
  // if there is no decimal point, then the amount is an integer
  if (decimalIndex === -1) {
    const integerAmount = parseInt(trimmedPayoutAmount);
    if (isPositiveInteger(integerAmount)) {
      return integerAmount * 100;
    } else {
      return false;
    }
  }

  const characterCount = trimmedPayoutAmount.length;
  const decimalDistanceFromEnd = characterCount - decimalIndex - 1;
  // if there are more than 2 digits after the decimal point or no digits after the decimal point, then the amount is invalid
  if (decimalDistanceFromEnd > 2 || decimalDistanceFromEnd === 0) {
    return false;
  }

  let removedDecimal = trimmedPayoutAmount.replace(".", "");
  // if there is only one digit after the decimal point, then add a zero
  if (decimalDistanceFromEnd === 1) {
    removedDecimal += "0";
  }
  const integerAmount = parseInt(removedDecimal);
  if (isPositiveInteger(integerAmount)) {
    return integerAmount;
  } else {
    return false;
  }
}
